export enum IntegrationCostPrice {
    TRADE_PRICE = 'TRADE_PRICE',
    RETAIL_SUPPLY_PRICE = 'RETAIL_SUPPLY_PRICE',
}
